<template>
  <div class="job-list">
    <h3>服务管理</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
      </el-form-item>
      <el-form-item label="人才昵称">
        <el-input v-model="filter.nickname" placeholder="人才昵称"></el-input>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="filter.talentId" placeholder="用户ID"></el-input>
      </el-form-item>
      <el-form-item label="服务ID">
        <el-input v-model="filter.serviceId" placeholder="服务ID"></el-input>
      </el-form-item>
      <el-form-item label="计费方式">
        <el-select v-model="filter.chargingWay" value-key="id" placeholder="请选择">
          <el-option v-for="item in billingMethod" :key="item.id" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="人才手机号">
        <el-input v-model="filter.phoneNum" placeholder="人才手机号"></el-input>
      </el-form-item>
      <el-form-item label="一级类目">
        <el-select v-model="filter.jobCate">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in firstCates" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级类目">
        <el-select v-model="filter.skillTag">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in secondCates" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="filter.showStatus">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(label, value) in map.service.showStatusList" :key="value" :label="label"
            :value="value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务状态">
        <el-select v-model="filter.serviceStatus">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(label, value) in map.service.serviceStatus" :key="value" :label="label"
            :value="value"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="关键词">
        <el-input v-model="filter.keyword" placeholder="关键词"></el-input>
      </el-form-item> -->
      <el-form-item label="创建时间从">
        <el-date-picker v-model="filter.createTimeStart" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="filter.createTimeEnd" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="更新时间从">
        <el-date-picker v-model="filter.updateTimeStart" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="filter.updateTimeEnd" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="goHotLIst()" size="mini">热门设置</el-button>
        <el-button type="primary" @click="$router.push('/service')" size="mini">新增服务</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="serviceTitle" label="服务标题">
        <template slot-scope="scope">
          <a :href="`${frontUrl}/service/detail/${scope.row.serviceId}`" target="_blank">{{ scope.row.serviceTitle
            }}</a>
        </template>
      </el-table-column>
      <el-table-column label="价格(元)">
        <template slot-scope="scope">
          <span v-if="scope.row.chargingWay === 1">
            <span v-if="scope.row.versions.length == 2">
              {{ scope.row.versions[0].price }} ~ {{ scope.row.versions[1].price }}元
            </span>
            <span v-else-if="scope.row.versions.length == 3">
              {{ scope.row.versions[0].price }} ~ {{ scope.row.versions[2].price }}元
            </span>
            <span v-else>
              {{ scope.row.projectPrice }} 元
            </span>
          </span>
          <span v-else>{{ scope.row.hourlyRate }} /时</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="chargingWay" label="计费方式">
        <template slot-scope="scope">{{
          scope.row.chargingWay === 1 ? '按件计费' : '按时计费'
        }}</template>
      </el-table-column> -->
      <el-table-column prop="serviceId" label="服务 ID"></el-table-column>

      <el-table-column prop="nickname" label="用户昵称">
        <template slot-scope="scope">
          <a :href="`${frontUrl}/resume/detail/${scope.row.userIdAES}`" target="_blank">{{ scope.row.nickname }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="talentId" label="用户 ID"></el-table-column>

      <el-table-column prop="phoneNum" label="手机号"></el-table-column>

      <el-table-column prop="jobCate" label="类目一级">
        <template slot-scope="scope">{{ scope.row.jobCate.name }}</template>
      </el-table-column>
      <el-table-column prop="skillTags" label="类目二级">
        <template slot-scope="scope">{{ scope.row.skillTags.name }}</template>
      </el-table-column>

      <el-table-column prop="exposureNum" label="累计曝光(次)"></el-table-column>
      <el-table-column prop="readNum" label="累计点击(次)"></el-table-column>
      <!-- <el-table-column prop="readNum" label="累计浏览(次)"></el-table-column> -->
      <el-table-column prop="connectIms" label="累计会话数(个)">
        <template slot-scope="scope"><a :href="`/sessions?entityId=${scope.row.serviceId}`">{{
          scope.row.connectIms
            }}</a></template>
      </el-table-column>
      <el-table-column prop="orderNum" label="累计下单(单)">
        <template slot-scope="scope"><a :href="`/orders?entityId=${scope.row.serviceId}`">{{
          scope.row.orderNum
            }}</a></template>
      </el-table-column>
      <el-table-column prop="totalSales" label="累计销量(单)"></el-table-column>
      <el-table-column prop="serviceDuration" label="累计服务时长(时)"></el-table-column>
      <el-table-column prop="totalIncome" label="累计成交(元)"></el-table-column>
      <el-table-column prop="score" label="评价平均分"></el-table-column>
      <el-table-column prop="totalFavorite" label="累计收藏量(人)"></el-table-column>
      <el-table-column prop="showStatus" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.showStatus == 0">待审核</span>
          <span v-if="scope.row.showStatus == 1">已通过</span>
          <span v-if="scope.row.showStatus == 2">未通过</span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceStatus" label="服务状态">
        <template slot-scope="scope">
          {{ scope.row.serviceStatus == 1 ? '上架中' : '已下架'
          }}</template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间">
        <template slot-scope="scope" v-if="scope.row.updateTime !== scope.row.createTime">{{ scope.row.updateTime
          }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column label="复制链接">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="copy-btn"
            :data-clipboard-text="`${frontUrl}/service/detail/${scope.row.serviceId}`"
            @click="copy"
            >复制链接</el-button
          >
        </template>
      </el-table-column>
      <!-- <el-table-column prop="operatorType" label="操作人">
      </el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item v-if="scope.row.showStatus !== 1"
                :command="{ action: 'pass', data: scope.row }">审核通过</el-dropdown-item>
              <el-dropdown-item v-if="scope.row.showStatus !== 2"
                :command="{ action: 'reject', data: scope.row }">审核不通过</el-dropdown-item> -->
              <el-dropdown-item v-if="scope.row.deleteStatus === 2"
                :command="{ action: 'delete', data: scope.row }">删除</el-dropdown-item>
              <el-dropdown-item v-else :command="{ action: 'delete', data: scope.row }">取消删除</el-dropdown-item>
              <el-dropdown-item command="">
                <a :href="`/service/${scope.row.serviceId}`" target="_blank">编辑服务</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination background layout="prev, pager, next" :current-page="pageNum"
        @current-change="(i) => (pageNum = i)" :page-size="limit" :total="total">
      </el-pagination>
    </div>

    <el-dialog title="选择不通过原因" :visible.sync="dialog.reject" class="dialog-reject" :close-on-click-modal="false">
      <el-form>
        <el-form-item>
          <el-select v-model="curData.reviseOpinion" multiple>
            <el-option v-for="(val, key) in reasons" :key="val.id" :value="val.reason" :label="val.reason"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateStatus(2)">确 定</el-button>
        <el-button @click="toggleDialog('reject')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { service, workCateList, common } = api;
import Clipboard from "clipboard";

export default {
  name: "services",
  data() {
    return {
      map,
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      total: 0,
      billingMethod: [
      {
          label: '全部',
          value: null
        },
        {
          label: '按时计费',
          value: 0
        },
        {
          label: '按件计费',
          value: 1
        }
      ],
      filter: {
        nickname: "",
        phoneNum: "",
        jobCate: "",
        skillTag: "",
        showStatus: "", // 1是，已认证人才的服务默认展示为是 ； 2否，未认证人才的服务默认展示为否
        serviceStatus: "", //1正常，用户发布后默认为正常 ； 2暂停，用户点击暂停服务后未暂停
        createTimeStart: "",
        createTimeEnd: "",
        updateTimeStart: "",
        updateTimeEnd: "",
        keyword: "",
        talentId: '',
        serviceId: '',
        chargingWay: '',
      },
      cates: [],
      dialog: {
        reject: false,
      },
      curData: {},
      closeReason: [],
      reasons: [],
    };
  },
  components: {},
  computed: {
    firstCates() {
      return this.getCatesById(0);
    },
    secondCates() {
      return this.getCatesById(this.filter.jobCate);
    },
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  mounted() {
    this.getAllTags();
    this.fetch();
    this.getReasons();
  },
  methods: {
    copy() {
      var clipboard = new Clipboard(".copy-btn");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.error("复制失败，请手动复制收款地址");
        // 释放内存
        clipboard.destroy();
      });
    },
    reset() {
      this.filter = {
        nickname: "",
        phoneNum: "",
        jobCate: "",
        skillTag: "",
        showStatus: "", 
        serviceStatus: "",
        createTimeStart: "",
        createTimeEnd: "",
        updateTimeStart: "",
        updateTimeEnd: "",
        keyword: "",
        talentId: '',
        serviceId: '',
        chargingWay: '',
      };
      this.fetch();
    },
    formatoperatorType() {
      if (type == 1) {
        return "系统";
      }
      if (type == 2) {
        return "人工";
      }
      if (type == 2) {
        return "用户";
      }
    },
    formatReason(data) {
      let str = "";
      if (data && data.length) {
        data.forEach((item, key) => {
          str += `${key + 1}、${item}<br>`;
        });
      }
      return str;
    },
    async getReasons() {
      let res = await common.getReasons({ type: 5 });
      if (res.data.code == 200) {
        this.reasons = res.data.data;
      }
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let {
        nickname,
        phoneNum,
        talentId,
        serviceId,
        chargingWay,
        jobCate,
        skillTag,
        showStatus,
        serviceStatus,
        createTimeStart,
        createTimeEnd,
        updateTimeStart,
        updateTimeEnd,
        keyword,
      } = this.filter;

      let res,
        obj = {};
      if (keyword) {
        obj = {
          pageNum: pageNum,
          limit: limit,
          keyword,
        };
        res = await service.search(obj);
      } else {
        obj = {
          pageNum: pageNum,
          limit: limit,
          nickname,
          phoneNum,
          talentId,
          serviceId,
          chargingWay,
          jobCate,
          skillTag,
          showStatus,
          serviceStatus,
          createTimeStart,
          createTimeEnd,
          updateTimeStart,
          updateTimeEnd,
        };
        res = await service.list(obj);
      }

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    async getAllTags() {
      let {
        data: { code, data },
      } = await workCateList.getAllTags();
      if (code == 200) {
        this.cates = data.workCategory;
      }
    },
    getCatesById(id) {
      let arr = [];
      this.cates.forEach((item) => {
        if (item.parentId === id) {
          arr.push(item);
        }
      });
      return arr;
    },
    handleCommand(command) {
      let action = command.action;
      let data = command.data;
      switch (action) {
        case "delete":
          this.toggleDelete(data);
          break;
        case "pass":
          this.curData = data;
          this.updateStatus(1);
          break;
        case "reject":
          this.curData = data;
          this.toggleDialog("reject", data);
          break;
        default:
      }
    },
    async toggleDelete(data) {
      let args = {
        serviceId: data.serviceId,
        deleteStatus: data.deleteStatus === 2 ? 1 : 2,
      };
      let {
        data: { code },
      } = await service.delete(args);
      if (code == 200) {
        this.$message.success("操作成功！");
        this.fetch(2);
      }
    },
    toggleDialog(name, data = {}) {
      this.dialog[name] = !this.dialog[name];
      this.curData = data;
      // this.closeReason = [];
    },
    async updateStatus(st) {
      let data = this.curData;
      let args = {
        serviceId: data.serviceId,
        showStatus: st,
        closeReason: data.reviseOpinion,
      };
      if (args.showStatus === 2 && !args.closeReason.length) {
        this.$message.error("不通过理由不允许为空");
        return false;
      }
      let {
        data: { code },
      } = await service.show(args);
      if (code == 200) {
        this.$message.success("操作成功！");
        if (args.showStatus === 2) {
          this.toggleDialog("reject");
        } else {
          this.curData = {};
        }
        this.fetch(2);
      }
    },
    goHotLIst() {
      this.$router.push({
        path: "/setHotLIst",
      });
    },
  },
};
</script>
<style>
.dialog-reject .el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/service/services.vue